import script from "./CommissionPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./CommissionPlans.vue?vue&type=script&setup=true&lang=js"

import "./CommissionPlans.vue?vue&type=style&index=0&id=079c0c78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079c0c78"]])

export default __exports__